import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.seal.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import '@wangeditor/editor/dist/css/style.css'; // 引入 css
import { addDays, format } from 'date-fns';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import selectPerson from '@/components/select-person';
import config from '@/pathConfig';
import { batchUploadFile, queryOrganByUser, updateWorkbench, editSystemNoticeState } from '@/api/commonApi.js';
import { saveNoticeFill, queryNoticeCate, submitNotice, queryNoticeFillDetails, querySendOutScope, judgeDirector, judgeDirectorJWB, saveNoticeFillNoCheck } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    var _this = this;
    var validateContent = function validateContent(rule, value, callback) {
      var pwdRegex = /<[^>]*>/g;
      if (!_this.editor.getText()) {
        callback({
          message: '请输入公告内容'
        });
        return;
      } else {
        if (value.replace(pwdRegex, '').length >= 10000) {
          callback(new Error('字数超出限制10000'));
          return;
        }
      }
      _this.$refs.addForm.clearValidate(['content']);
      callback();
    };
    var tabList = [{
      title: '组织岗位成员',
      value: 3
    }];
    return {
      config: config,
      tabList: tabList,
      options: [],
      // 级联选择数据
      userInfo: this.$hdk.userInfo.get(),
      loading: false,
      optionAll: false,
      optionVal: [],
      selectOption: '',
      optionData: [],
      businessId: 2,
      // 业务id 1公文流转 2通知通告
      cardTitle: '通知公告拟稿',
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      cateList: [],
      formObject: {
        id: '',
        typeId: '',
        organId: '',
        postId: '',
        organPostId: [],
        type: undefined,
        title: '',
        digest: '',
        sort: '',
        content: '',
        range: 2,
        emergency: 1,
        isTop: 0,
        isAppend: 0,
        // 是否追加 0否 1是
        attach: [],
        customize: {
          organId: '',
          postId: '',
          userData: [],
          postData: [],
          organData: []
        },
        scope: []
      },
      rules: {
        type: [{
          required: true,
          message: '请选择通知公告分类'
        }],
        title: [{
          required: true,
          message: '请输入公告标题'
        }, {
          max: 200,
          message: '字数超出限制200'
        }],
        digest: [{
          required: true,
          message: '请输入摘要'
        }, {
          max: 100,
          message: '字数超出限制100'
        }],
        sort: [{
          required: true,
          message: '请输入公告排序'
        }],
        organPostId: [{
          required: true,
          message: '请选择所属组织及岗位'
        }],
        content: [{
          required: true,
          message: '请输入公告内容'
        }, {
          validator: validateContent
        }]
      },
      fileObj: [],
      editor: null,
      toolbarConfig: {
        excludeKeys: ['fullScreen', 'group-video']
      },
      editorConfig: {
        placeholder: '请输入公告内容'
      },
      mode: 'default',
      // or 'default'
      allDisabled: false,
      isDirector: false,
      isDirectorJWB: false,
      isShowButton: '',
      showButtonName: ''
    };
  },
  created: function created() {
    var userInfo = this.userInfo;
    // 级联数据处理
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        typeId: item.typeId,
        children: item.postList
      };
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    var $set = this.$set,
      $refs = this.$refs,
      $route = this.$route,
      getNoticeCate = this.getNoticeCate,
      formObject = this.formObject,
      getOrganByUser = this.getOrganByUser;
    getNoticeCate();
    var parma = {
      msgId: $route.query.id
    };
    this.isShowButton = $route.query.flag;
    if (this.isShowButton == 0) {
      this.showButtonName = '提交';
    } else {
      this.showButtonName = '发布';
    }
    if ($route.query.look == 'updateWorkbench') {
      updateWorkbench(parma).then(function (res) {});
    }
    if ($route.query.look == 'editSystemNoticeState' || $route.query.looks == 'editSystemNoticeState') {
      editSystemNoticeState($route.query).then(function (res) {});
    }
    var parmas = {
      msgId: $route.query.msgId,
      noticeType: $route.query.noticeType
    };
    // 判断新增、编辑、查看
    if ($route.query.id && ($route.query.type == 1 || $route.query.type == 2)) {
      if ($route.query.type == 1) {
        this.cardTitle = '通知公告编辑';
      } else if ($route.query.type == 2) {
        this.cardTitle = '通知公告查看';
      }
      queryNoticeFillDetails($route.query.id).then(function (res) {
        _this2.formObject = res.data.data;
        _this2.formObject.organPostId = [_this2.formObject.organId, _this2.formObject.postId];
        getOrganByUser();
        var newOrganIdAndPost = {
          organId: _this2.formObject.organId,
          postId: _this2.formObject.postId
        };
        // 在通知公告选择发送范围的时判断是否能选择全校教职工
        querySendOutScope(newOrganIdAndPost).then(function (res) {
          _this2.allDisabled = res.data.data;
        });
        // 判断财务室主任提交时是否需要财务总监审核
        judgeDirector(newOrganIdAndPost).then(function (res) {
          _this2.isDirector = res.data.data;
        });
        // 判断是否是纪委办主任
        judgeDirectorJWB(newOrganIdAndPost).then(function (res) {
          _this2.isDirectorJWB = res.data.data;
        });
        // 当前组织层级指定人员
        if (_this2.formObject.range === 3) {
          _this2.optionVal = _.map(_this2.formObject.scope, function (item) {
            return item.userId;
          });
        } else {
          _this2.formObject.customize = {};
          // sendType 发送类型 0 个人 1 组织 2 岗位
          _this2.formObject.customize.userData = [];
          _this2.formObject.customize.organData = [];
          _this2.formObject.customize.postData = [];
          _.forEach(_this2.formObject.scope, function (item) {
            if (item.sendType === 0) {
              _this2.formObject.customize.userData.push({
                id: item.userId,
                name: item.userName,
                type: 1
              });
            }
            if (item.sendType === 1) {
              _this2.formObject.customize.organData.push({
                id: item.organId,
                name: item.organName,
                typeId: item.typeId
              });
            }
            if (item.sendType === 2) {
              _this2.formObject.customize.postData.push({
                id: item.postId,
                name: item.postName,
                type: 2
              });
            }
          });
          _this2.formObject.customize.organId = _this2.formObject.organId;
          _this2.formObject.customize.postId = _this2.formObject.postId;
        }
        _this2.fileObj = _.map(res.data.data.attach, function (item) {
          return {
            fileid: item.id,
            filename: item.fileName,
            filepath: item.filePath,
            uid: item.id,
            name: item.fileName,
            status: 'done',
            type: 1
          };
        });
      });
      if ($refs.addForm) {
        $refs.addForm.clearValidate();
      }
    } else {
      this.cardTitle = '通知公告拟稿';
      $set(formObject, 'id', '');
      if ($refs.addForm) {
        $refs.addForm.clearValidate();
      }
    }
  },
  methods: {
    /*
     * 公告分类
     */
    getNoticeCate: function getNoticeCate() {
      var _this3 = this;
      queryNoticeCate().then(function (res) {
        _this3.cateList = res.data.data;
      });
    },
    /*
     * 存为草稿
     */
    saveDraft: function saveDraft() {
      var _this4 = this;
      var $refs = this.$refs,
        $set = this.$set,
        $confirm = this.$confirm,
        formObject = this.formObject,
        fileObj = this.fileObj,
        callSaveNoticeFill = this.callSaveNoticeFill;
      $refs.addForm.validate(function (valid) {
        if (valid) {
          // 上传附件
          if (fileObj.length > 0) {
            var newFileObj = _.map(fileObj, function (item) {
              if (item.type === 0) {
                return item;
              } else {
                return;
              }
            });
            // 去除为空的
            newFileObj = _.compact(newFileObj);
            _this4.formObject.attach = _.remove(fileObj, function (n) {
              if (n.type === 1) {
                return n;
              }
            });

            // 判断处理后的附件是否为空,为空表示没有新上传附件
            if (newFileObj.length > 0) {
              batchUploadFile(newFileObj).then(function (res) {
                _.map(res.data.data, function (item) {
                  _this4.formObject.attach.push({
                    filename: item.originalName,
                    filepath: item.filepath,
                    originalname: item.originalName
                  });
                });
                callSaveNoticeFill(1);
              });
            } else {
              callSaveNoticeFill(1);
            }
          } else {
            callSaveNoticeFill(1);
          }
        }
      });
    },
    /*
     * 调用存入草稿的接口
     */
    callSaveNoticeFill: function callSaveNoticeFill(flag) {
      var _this5 = this;
      var $set = this.$set,
        $message = this.$message,
        formObject = this.formObject,
        goBack = this.goBack,
        optionVal = this.optionVal;
      return new Promise(function (resolve, reject) {
        var newData = [];
        if (_this5.formObject.customize) {
          // 组织数据处理
          _.forEach(formObject.customize.organData, function (item) {
            newData.push({
              sendtype: 1,
              typeid: item.typeId,
              organid: item.id,
              postid: '',
              userid: ''
            });
          });
          // 岗位数据处理
          _.forEach(formObject.customize.postData, function (item) {
            newData.push({
              sendtype: 2,
              typeid: '',
              organid: '',
              postid: item.id,
              userid: ''
            });
          });
          // 成员数据处理
          _.forEach(formObject.customize.userData, function (item) {
            newData.push({
              sendtype: 0,
              typeid: '',
              organid: '',
              postid: '',
              userid: item.id
            });
          });
        }

        // 当前组织层级指定人员
        if (_this5.formObject.range === 3) {
          _this5.formObject.scope = _.map(optionVal, function (item) {
            return {
              userid: item,
              sendtype: 0
            };
          });
        } else {
          _this5.formObject.scope = newData;
        }
        _this5.loading = true;
        formObject.isCehck = parseInt(_this5.isShowButton);
        saveNoticeFill(_objectSpread({}, formObject)).then(function (res) {
          if (res.data.code == 200 && flag == 1) {
            $message.success('保存成功');
            goBack();
          } else if (res.data.code == 200 && flag == 0) {
            resolve(res.data.data);
          }
          _this5.loading = false;
        });
      });
    },
    /*
     * 提交通知公告
     */
    submitNotice: function submitNotice() {
      var _this6 = this;
      var $refs = this.$refs,
        $confirm = this.$confirm,
        fileObj = this.fileObj,
        mySubmitNotice = this.mySubmitNotice,
        isShowButton = this.isShowButton,
        myNoCheckSubmitNotice = this.myNoCheckSubmitNotice;
      $refs.addForm.validate(function (valid) {
        if (valid) {
          _this6.loading = true;
          // isShowButton 0 要走审批流程  1 不走审批流程
          if (isShowButton == 0) {
            $confirm('确认提交吗?', '提示', {
              type: 'info',
              confirmButtonText: '确认',
              cancelButtonText: '取消'
            }).then(function () {
              // 上传附件
              if (fileObj.length > 0) {
                var newFileObj = _.map(fileObj, function (item) {
                  if (item.type === 0) {
                    return item;
                  } else {
                    return;
                  }
                });
                // 去除为空的
                newFileObj = _.compact(newFileObj);
                _this6.formObject.attach = _.remove(fileObj, function (n) {
                  if (n.type === 1) {
                    return n;
                  }
                });

                // 判断处理后的附件是否为空,为空表示没有新上传附件
                if (newFileObj.length > 0) {
                  batchUploadFile(newFileObj).then(function (res) {
                    _.map(res.data.data, function (item) {
                      _this6.formObject.attach.push({
                        filename: item.originalName,
                        filepath: item.filepath,
                        originalname: item.originalName
                      });
                    });
                    mySubmitNotice();
                  });
                } else {
                  mySubmitNotice();
                }
              } else {
                mySubmitNotice();
              }
            }).catch(function () {
              _this6.loading = false;
            });
          } else {
            $confirm('确认发布吗?', '提示', {
              type: 'info',
              confirmButtonText: '确认',
              cancelButtonText: '取消'
            }).then(function () {
              // 上传附件
              if (fileObj.length > 0) {
                var newFileObj = _.map(fileObj, function (item) {
                  if (item.type === 0) {
                    return item;
                  } else {
                    return;
                  }
                });
                // 去除为空的
                newFileObj = _.compact(newFileObj);
                _this6.formObject.attach = _.remove(fileObj, function (n) {
                  if (n.type === 1) {
                    return n;
                  }
                });

                // 判断处理后的附件是否为空,为空表示没有新上传附件
                if (newFileObj.length > 0) {
                  batchUploadFile(newFileObj).then(function (res) {
                    _.map(res.data.data, function (item) {
                      _this6.formObject.attach.push({
                        filename: item.originalName,
                        filepath: item.filepath,
                        originalname: item.originalName
                      });
                    });
                    myNoCheckSubmitNotice();
                  });
                } else {
                  myNoCheckSubmitNotice();
                }
              } else {
                myNoCheckSubmitNotice();
              }
            }).catch(function () {
              _this6.loading = false;
            });
          }
        }
      });
    },
    mySubmitNotice: function mySubmitNotice() {
      var _this7 = this;
      var $message = this.$message,
        formObject = this.formObject,
        callSaveNoticeFill = this.callSaveNoticeFill,
        goBack = this.goBack;
      if (formObject.id) {
        callSaveNoticeFill(0).then(function (res) {
          submitNotice(formObject).then(function (res) {
            if (res.data.code == 200) {
              $message.success('提交成功');
              goBack();
            }
            _this7.loading = false;
          });
        });
      } else {
        callSaveNoticeFill(0).then(function (res) {
          _this7.formObject.id = res; // 赋值存为草稿的主键id用于提交
          submitNotice(formObject).then(function (res) {
            if (res.data.code == 200) {
              $message.success('提交成功');
              goBack();
            }
            _this7.loading = false;
          });
        });
      }
    },
    myNoCheckSubmitNotice: function myNoCheckSubmitNotice() {
      var _this8 = this;
      var $message = this.$message,
        formObject = this.formObject,
        goBack = this.goBack,
        optionVal = this.optionVal;
      var newData = [];
      if (this.formObject.customize) {
        // 组织数据处理
        _.forEach(formObject.customize.organData, function (item) {
          newData.push({
            sendtype: 1,
            typeid: item.typeId,
            organid: item.id,
            postid: '',
            userid: ''
          });
        });
        // 岗位数据处理
        _.forEach(formObject.customize.postData, function (item) {
          newData.push({
            sendtype: 2,
            typeid: '',
            organid: '',
            postid: item.id,
            userid: ''
          });
        });
        // 成员数据处理
        _.forEach(formObject.customize.userData, function (item) {
          newData.push({
            sendtype: 0,
            typeid: '',
            organid: '',
            postid: '',
            userid: item.id
          });
        });
      }
      // 当前组织层级指定人员
      if (this.formObject.range === 3) {
        this.formObject.scope = _.map(optionVal, function (item) {
          return {
            userid: item,
            sendtype: 0
          };
        });
      } else {
        this.formObject.scope = newData;
      }
      this.loading = true;
      saveNoticeFillNoCheck(formObject).then(function (res) {
        if (res.data.code == 200) {
          $message.success('发布成功');
          goBack();
        }
        _this8.loading = false;
      });
    },
    /**
     * 文件大小
     */
    beforeUpload: function beforeUpload(file) {
      var $message = this.$message;
      var isLt1M = file.size / 1024 / 1024 < 500;
      if (!isLt1M) {
        $message.error('最大只能上传500MB');
      }
      return isLt1M;
    },
    /**
     * 文件删除
     */
    delFile: function delFile(data) {
      var fileObj = this.fileObj;
      if (1 === fileObj.length) {
        this.fileObj = [];
        this.formObject.attach = [];
      } else {
        var evens = _.remove(fileObj, function (n) {
          if (n.fileid != data.fileid) {
            return n;
          }
        });
        this.fileObj = evens;
        this.formObject.attach = evens;
      }
    },
    /**
     * 文件上传存值
     */
    actionUpload: function actionUpload(data) {
      var $message = this.$message,
        fileObj = this.fileObj;
      if (fileObj.length > 5) {
        $message.error('文件最多同时上传5个');
        return;
      }
      // 用于上传后回显及往文件对象存值
      this.fileObj.push({
        fileid: data.file.uid,
        filename: data.file.name,
        fileSize: data.file.size,
        file: data.file,
        uid: data.file.uid,
        name: data.file.name,
        status: 'done',
        type: 0
      });
    },
    /**
     * 编辑器
     */
    onCreated: function onCreated(editor) {
      var $route = this.$route,
        config = this.config,
        $message = this.$message;
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错

      var toolbarConfig = this.editor.getConfig();
      toolbarConfig.MENU_CONF['uploadImage'] = {
        allowedFileTypes: ['image/*'],
        maxNumberOfFiles: 1,
        customUpload: function customUpload(file, insertFn) {
          return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            var url, alt, href, regJPGPNG, isLt5M;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  url = '';
                  alt = '';
                  href = '';
                  regJPGPNG = /^.*\.(?:jpg|png|gif|)$/i;
                  if (regJPGPNG.test(file.name)) {
                    _context.n = 1;
                    break;
                  }
                  $message.error('上传的格式不支持，请重新选择');
                  return _context.a(2);
                case 1:
                  isLt5M = file.size / 1024 / 1024 < 5;
                  if (isLt5M) {
                    _context.n = 2;
                    break;
                  }
                  $message.error('最大只能上传5MB');
                  return _context.a(2);
                case 2:
                  // 自己实现上传，并得到图片 url alt href
                  batchUploadFile([{
                    file: file
                  }]).then(function (res) {
                    _.map(res.data.data, function (item) {
                      url = "".concat(config.baseUrl, "noticePath").concat(item.filepath);
                      alt = item.originalName;
                    });
                    // 最后插入图片
                    insertFn(url, alt, href);
                  });
                case 3:
                  return _context.a(2);
              }
            }, _callee);
          }))();
        }
      };

      // 编辑器禁用
      if ($route.query.id && $route.query.type == 2) {
        this.editor.disable();
      }
    },
    /*
     * 开始时间禁用范围
     */
    disabledStart: function disabledStart(current) {
      var now = new Date();
      var dayTime = addDays(now, -1);
      return current < dayTime;
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      var _this9 = this;
      var $set = this.$set,
        formObject = this.formObject,
        getOrganByUser = this.getOrganByUser;
      // 组织岗位赋值
      $set(formObject, 'organId', value[0]);
      $set(formObject, 'postId', value[1]);
      $set(formObject, 'typeId', option[0].typeId);
      this.formObject.customize = {};
      this.formObject.customize.organId = value[0];
      this.formObject.customize.postId = value[1];
      var newOrganIdAndPost = {
        organId: value[0],
        postId: value[1]
      };
      // 判断财务室主任提交时是否需要财务总监审核
      judgeDirector(newOrganIdAndPost).then(function (res) {
        _this9.isDirector = res.data.data;
      });
      // 判断是否是纪委办主任
      judgeDirectorJWB(newOrganIdAndPost).then(function (res) {
        _this9.isDirectorJWB = res.data.data;
      });
      getOrganByUser();
      // 在通知公告选择发送范围的时判断是否能选择全校教职工
      querySendOutScope(newOrganIdAndPost).then(function (res) {
        _this9.allDisabled = res.data.data;
      });
      // 清空“当前组织层级指定人员”数据
      this.optionVal = [];
    },
    /**
     * 根据组织查询人员
     */
    getOrganByUser: function getOrganByUser() {
      var _this0 = this;
      var $refs = this.$refs,
        $set = this.$set,
        formObject = this.formObject;
      queryOrganByUser({
        organId: formObject.organId,
        typeId: formObject.typeId
      }).then(function (res) {
        _this0.optionData = res.data.data;
        _this0.selectOption = $refs.currOrganCascader.$el.innerText;
      });
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      // this.$router.push({
      //     path: '/docNotice/notice/publish',
      // });
      this.$router.go(-1);
    },
    /*
     * 自定义
     */
    switchItem: function switchItem(e) {
      var optionAll = this.optionAll,
        optionData = this.optionData;
      if (optionAll) {
        this.optionAll = false;
        this.optionVal = [];
      } else {
        this.optionAll = true;
        var organIds = [];
        // 处理全选数据
        _.forEach(optionData, function (item) {
          organIds.push(item.userId);
        });
        this.optionVal = organIds;
      }
      e.preventDefault();
    }
  },
  beforeDestroy: function beforeDestroy() {
    var editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
  components: {
    Editor: Editor,
    Toolbar: Toolbar,
    selectPerson: selectPerson,
    VNodes: {
      functional: true,
      render: function render(h, ctx) {
        return ctx.props.vnodes;
      }
    }
  }
};